import React from 'react';
import {
  Paper,
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Button,
  InputAdornment,
} from '@mui/material';
import { Search as SearchIcon, FilterAltOff as ClearFiltersIcon } from '@mui/icons-material';

const FilterPanel = ({
  searchQuery,
  onSearchChange,
  filters = [],
  onFilterChange,
  onClearFilters,
}) => {
  return (
    <Paper sx={{ p: 2, mb: 3 }}>
      <Grid container spacing={2} alignItems="center">
        {/* Search Field - Reduced size to fit everything on one line */}
        <Grid item xs={12} md={3}>
          <TextField
            fullWidth
            size="small"
            placeholder="Search..."
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>

        {/* Dynamic Filters */}
        {filters.map((filter, index) => (
          <Grid item xs={12} md={2} key={index}>
            <FormControl fullWidth size="small">
              <InputLabel>{filter.label}</InputLabel>
              <Select
                value={filter.value}
                onChange={(e) => onFilterChange(filter.name, e.target.value)}
                label={filter.label}
              >
                <MenuItem value="">
                  <em>All {filter.label}</em>
                </MenuItem>
                {filter.options.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
        ))}

        {/* Clear Filters Button */}
        <Grid item xs="auto">
          <Button
            variant="outlined"
            size="small"
            onClick={onClearFilters}
            startIcon={<ClearFiltersIcon />}
            sx={{ 
              minWidth: 'auto',
              px: 2,
              height: 40
            }}
          >
            Clear
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default FilterPanel;
